module.exports = __webpack_public_path__ + "static/ssb-duizhen-e23d2f7be50601d4b5cf332e2cd18daa.png";